import React from "react";
import Line from "../../components/Line";
import { useNavigate } from "react-router-dom";
import { Route, Routes } from "react-router-dom";

const LinePage = (props) => {
  const navigate = useNavigate();
  const onNavigate = (path) => {
    navigate(path);
  };

  return (
    <Routes>
      <Route path="" element={<Line onNavigate={onNavigate} mode="auth" />} />
      <Route
        path="link"
        element={<Line onNavigate={onNavigate} mode="link" />}
      />
    </Routes>
  );
};

LinePage.propTypes = {};

export default LinePage;
